<template>
        <div class="container">
            <div class="custom-breadcrumb">
                <o-bread-crumb>
                    <template v-slot:pageName>
                        Branch
                    </template>
                    <template v-slot:pageDetail>
                        {{ page.cardTitle }}
                    </template>
                </o-bread-crumb>
            </div>
            <div v-if="error" class="alert alert-danger" role="alert">
                {{ error }}
            </div>
            <o-card :card-title="page.cardTitle" class="custom-table mw-700">
                <o-form @submit.prevent="change()" autocomplete="off">
                    <o-form autocomplete="off">
                        <div class="d-flex justify-content-between me-2">
                            <o-input-text name="code" v-model="branch.id" type="hidden" :required="true" :autocomplete="'off'"/>
                            <div class="col-md-6 me-2">
                                <o-form-group title="name" name="name">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="name" :autocomplete="'off'" v-model="branch.name" type="text" :required="true"/>
                                    <div v-if="validation.name">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.name[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="code" name="code">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="code" v-model="branch.code" type="text" :required="true" :autocomplete="'off'"/>
                                        <div v-if="validation.code">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.code[0] }}
                                            </div>
                                        </div>
                                </o-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="city/area" name="city">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="city" v-model="branch.city" type="text" autocomplete="'off'"></o-input-text>
                                    <div v-if="validation.city">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.city[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="state/province" name="state">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="state" v-model="branch.state" type="text" :required="true" autocomplete="'off'"/>
                                    <div v-if="validation.state">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.state[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="postcode" name="postcode">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="postcode" v-model="branch.postcode" :required="true" type="text" autocomplete="'off'"></o-input-text>
                                    <div v-if="validation.postcode">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.postcode[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="country" name="country">
                                    <span class="text-danger"> *</span>
                                    <o-select v-model="branch.country" :options="options" autocomplete="'off'"></o-select>
                                    <div v-if="validation.country">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.country[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                        </div>
                        <o-form-group title="address" name="address">
                            <o-textarea 
                                name="address"
                                v-model="branch.address"
                                placeholder="enter your additional address information"
                                style="height: 45px"
                                for="address"
                                id="address"
                                autocomplete="'off'"
                            ></o-textarea>
                            <div v-if="validation.address">
                                <div class="alert alert-danger mt-1" role="alert">
                                    {{ validation.address[0] }}
                                </div>
                            </div>
                        </o-form-group>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 pe-2">
                                <o-form-group title="phone" name="phone">
                                    <span class="text-danger"> *</span>
                                    <div class="d-flex">
                                        <div style="width: 25%;" v-if="!unknownCountry">
                                          <o-input-text
                                            name="countryCode"
                                            :autocomplete="'off'"
                                            v-model="countryCode"
                                            type="text"
                                            :required="true"
                                            :readonly="true"
                                            :disabled="true"
                                          />
                                        </div>
                                        <div style="width: 100%;">
                                          <o-input-text
                                            name="phone"
                                            :autocomplete="'off'"
                                            v-model="branch.phone"
                                            type="text"
                                            :required="true"
                                            :numbers-only="true"
                                          />
                                        </div>
                                      </div>
                                    <div v-if="validation.phone">
                                      <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.phone[0] }}
                                      </div>
                                    </div>
                                  </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="fax" name="fax">
                                    <o-input-text mask="fax" name="fax" v-model="branch.fax" type="text" autocomplete="'off'"/>
                                    <div v-if="validation.fax">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.fax[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="website url" name="website">                                    
                                    <o-input-text name="website" v-model="branch.website" type="text" :required="true" autocomplete="'off'"/>
                                    <div v-if="validation.website">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.website[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="commerce site" name="commerce">
                                    <o-input-text name="commerce" v-model="branch.commerce_site" type="text" autocomplete="'off'"/>
                                    <div v-if="validation.commerce_site">
                                        <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.commerce_site[0] }}
                                        </div>
                                    </div>
                                </o-form-group>
                            </div>
                        </div>
                        <o-form-group title="logo" name="logo">
                            <o-image-input name="logo" id="logo" :imageurl="image.url" @selectImage="imageHandling"></o-image-input>
                        </o-form-group>
                    </o-form>
                    <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="page.isLoading"></div>
                    <div class="spinner" v-if='page.isLoading'></div>
                    <div class="button-container mt-3">
                        <o-button type="submit" :size="'sm'" :variant="'primary'" :white="'white'">
                          Save
                        </o-button>
                        <o-button @click="cancel()" :size="'sm'" :variant="'outline-secondary'" :white="'white'">
                            Cancel
                        </o-button>
                    </div>
                </o-form>
            </o-card>
        </div>
</template>

<script>
import { OCard, OForm, OFormGroup, OInputText, OButton, OTextarea, OSelect, OImageInput, OBreadCrumb} from '@/components/OmnihControl';
import { reactive, ref, onMounted, watch} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import store from '@/store';
import { isSupportedCountry, getCountryCallingCode } from 'libphonenumber-js';
import { getCode } from 'country-list';


export default {
    name: 'Addbranch',
    components: {
        OCard,
        OForm,
        OFormGroup,
        OInputText,
        OButton,
        OTextarea,
        OSelect,
        OImageInput,
        OBreadCrumb
    },
    setup(){
        const page = reactive({
            isLoading: false,
            cardTitle: 'Create branch'
        });

        const branch = reactive({
            id: "",
            corporate_id: "",
            code: '',
            name: '',
            logo: '',
            address: '',
            state: '',
            country: 0,
            phone: '',
            fax: '',
            website: '',
            commerce_site: '',
            city: '',
            postcode: ''
        });

        const image = reactive({
            url: ''
        })

        const options = ref([]);

        const validation = ref([]);
        const error = ref('');
        
        const router = useRouter();

        const route = useRoute();

        const countryCode = ref('');

        const unknownCountry = ref(false);

        const countries = ref([]);

        const branchCountry = ref();

        onMounted(async() => {
            page.isLoading = true;

            await loadCountries();

            if (route.params.id) {
                await loadState(route.params.id);
            }

            page.isLoading = false;
        });

        async function loadCountries() {
            try {
                const response = await store.dispatch('Countries/read');
                countries.value = response.map(country => ({ value: country.id, text: country.name }));
                options.value = countries.value;
                if (countries.value.length > 0) {
                loadCorporate();
                }
            } catch (err) {
                console.error(err);
            }
        }

        function loadCorporate() {
            store.dispatch('Auth/getBusinessProfile').then((business_profile) => {
                branch.corporate_id = business_profile.corporate_id;
            });
        }

        async function loadState(id) {
            page.isLoading = true; // Set loading true

            try {
                const data = await store.dispatch('Branch/read_single', id);
                page.cardTitle = 'Edit branch';

                branch.country = data.business_profile.country;
                branch.id = data.id;
                branch.code = data.code;
                branch.name = data.name;
                branch.corporate_id = data.corporate_id;
                branch.address = data.business_profile.address;
                branch.state = data.business_profile.state;
                branch.phone = removeCountryCode(data.business_profile.phone);
                branch.fax = data.business_profile.fax;
                branch.website = data.business_profile.website;
                branch.commerce_site = data.business_profile.commerce_site;
                branch.city = data.business_profile.city;
                branch.postcode = data.business_profile.postcode;

                image.url = data.business_profile.logo.image_url;

            } catch (error) {
                console.error('Error loading state:', error); // Log error if needed
            } finally {
                page.isLoading = false; // Set loading false
            }
        }

        function updatePhoneCode() {
            if (!countries.value || countries.value.length === 0) {
                console.error('Countries data is not loaded yet.');
                return;
            }
            
            const countryName = countries.value.find(country => country.value === parseInt(branch.country));
            
            if (countryName) {
                branchCountry.value = countryName;
                const code = getCode(branchCountry.value.text);
                if (isSupportedCountry(code)) {
                    unknownCountry.value = false;
                    const phoneCode = getCountryCallingCode(code);
                    if (phoneCode) {
                        countryCode.value = `+${phoneCode} `;
                    }
                } else {
                    unknownCountry.value = true;
                    console.error(`Unknown country: ${branchCountry.value.text}`);
                }
            } else {
                unknownCountry.value = true;
                console.error(`Country not found for branch country: ${branch.country}`);
            }
        }

        function removeCountryCode(phone) {
            const countryName = countries.value.find(country => country.value === parseInt(branch.country));
            if (countryName) {
                branchCountry.value = countryName;
                const code = getCode(branchCountry.value.text);
                if (isSupportedCountry(code)) {
                    unknownCountry.value = false;
                    const phoneCode = getCountryCallingCode(code);
                    if (phoneCode) {
                        const countryCodePattern = new RegExp(`^\\+${phoneCode}`);
                        return phone.replace(countryCodePattern, '').trim();
                    }
                } else {
                    unknownCountry.value = true;
                    console.error(`Unknown country: ${branchCountry.value.text}`);
                }
            } else {
                unknownCountry.value = true;
                console.error(`Country not found for branch country: ${branch.country}`);
            }
            return phone;
        }

        function imageHandling(img){
            branch.logo = img;
        }

        function change(){

            const data = {...branch}
            data.phone = countryCode.value + data.phone;

            page.isLoading = true;

            if(route.name != 'BranchForm'){

                if (data.logo == '') {
                    delete data.logo;
                }
    
                store.dispatch('Branch/update',{data}).then(() => {
                    router.push({
                        name: 'Branch',
                    })
                }).catch((err) => {
                    if(err.response && err.response.status === 403){
                        error.value = err.response.data.message
                    }else{
                        validation.value = JSON.parse(err.response.data.error)
                        
                        if (data.country === 0 || data.country === '') {
                            validation.value.country = ['Country is required.'];
                            page.isLoading = false;
                            return; 
                        } else {
                            delete validation.value.country; 
                        }
                    }
                }).finally(() =>{
                    page.isLoading = false
                });

            }else{

                store.dispatch('Branch/create',{data}).then(() => {
                    router.push({
                        name: 'Branch',
                        query: { newBranch: 'true' }
                    })
                }).catch((err) => {
                    if(err.response && err.response.status === 403){
                        error.value = err.response.data.message
                    }else{
                        validation.value = JSON.parse(err.response.data.error)
                        
                        if (data.country === 0 || data.country === '') {
                            validation.value.country = ['Country is required.'];
                            page.isLoading = false;
                            return; 
                        } else {
                            delete validation.value.country;
                        }
                    }
                }).finally(() => {
                    page.isLoading = false;
                });
            }
        }

        function cancel() {
            router.push({ name: 'Branch' });
        }

        watch(() => branch.country, updatePhoneCode);
        
        return {
            branch,
            page,
            validation,
            router,
            options,
            route,
            change,
            imageHandling,
            image,
            countryCode,
            unknownCountry,
            countries,
            cancel,
            error
        }
    }
}

</script>